import { render, staticRenderFns } from "./MaterialPreviewerTable.vue?vue&type=template&id=14c21280&scoped=true&"
import script from "./MaterialPreviewerTable.vue?vue&type=script&lang=js&"
export * from "./MaterialPreviewerTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPreviewerTable.vue?vue&type=style&index=0&id=14c21280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c21280",
  null
  
)

export default component.exports